/**
 * Created by chenzhiqiang on 2020/4/22
 */

const mapKey = '360745ced14df5f078dbb6cfa7d86bde'
const serverKey = '3335ba1b5618d1aacea8ab44be7475d2'

export {
  mapKey,
  serverKey
}



// WEBPACK FOOTER //
// ./src/utils/mapKey.js